/*eslint no-unused-vars: "off"*/
export enum SERVICE_SESSION {
    MORNING = 'MORNING',
    EVENING = 'EVENING'
}

export enum PARENT_ROLES {
    PARENT = 'parent',
    TEACHER = 'teacher',
    PARENT_TEACHER = 'parent-teacher'
}

export enum APPROVAL_STATUS {
    PENDING = 'pending',
    APPROVED = 'approved',
    DOWNGRADED = 'downgraded'
}

export enum JobStatus {
    SUCCESS = 'success',
    FAILED = 'failed',
    PENDING = 'pending',
    ERROR = 'error'
}

export enum PARENT_CHILD_RELATIONSHIPS {
    FATHER = 'Father',
    MOTHER = 'Mother',
    GUARDIAN = 'Guardian',
    NONE = 'N/A'
}
